import React from 'react'
import { useParams } from 'react-router-dom'
import { BeeEditorWrapper } from './../containers'

const ViewPluginEditor = () => {
  const params = useParams()
  return (
    <BeeEditorWrapper {...params} topbar={false} bottombar={false} />
  )
}

export default ViewPluginEditor
